<template>
    <a class="wrapper" :href="card.url"
      :class="{small: size=='small', large: size=='large'}"
      :style="`background-color: ${card.color ? card.color : '#cccccc'}`"
      @click.prevent="openLink()">
        <div class="cardLabel">{{card.label}}</div>
        <div v-if="card.description" class="description">{{card.description}}</div>
        <div class="spacer"></div>
        <div class="viewLink" :class="{'viewed':viewed}">
            <div v-if="size == 'large'" :style="`color: ${card.color ? card.color : '#cccccc'}`">
                <span class="linkText" >{{viewed ? 'Viewed!' : 'View Now'}}</span>
                <i v-if="viewed" class="fas fa-check-square ml-2"></i>
                <i v-else class="fas fa-external-link-alt ml-2"></i>
            </div>

            <div v-if="size == 'small'">
                <span class="linkText" >{{viewed ? 'Viewed!' : 'View Now'}}</span>
                <i v-if="viewed" class="fas fa-lg fa-check-square ml-3"></i>
                <i v-else class="fas fa-lg fa-external-link-alt ml-3"></i>
            </div>
        </div>
    </a>
</template>

<script lang="ts" setup>
import { InformationCard } from "../model";

const props = defineProps<{
  card: InformationCard
  viewed?: boolean,
  size: "small"|"large"
}>();

const emit = defineEmits(['viewed'])

const openLink = () => {
    window.open(props.card.url);
    emit('viewed');
}

</script>

<style scoped>
    .wrapper {
        width: 100%;
        color: white;
        border-radius: 0.3em;

        display: flex;
        align-items: center;

        cursor: pointer;
    }

    .small {
        flex-direction: row;

        padding-left: 3em;
        padding-right: 3em;
        padding-top: 0.6em;
        padding-bottom: 0.6em;
    }

    .large {
        flex-direction: column;

        padding-left: 2em;
        padding-right: 2em;
        padding-top: 1.7em;
        padding-bottom: 1.7em;
    }

    .spacer {
        flex-grow: 1;
    }
    
    .cardLabel {
        font-size: 1.2em;
        font-weight: bold;
        text-align: center;
    }

    .description {
        font-size: 0.8em;
        margin-top: 0.3em;
    }

    .large .viewLink {
        background-color: white;
        padding-top: 0.35em;
        padding-bottom: 0.35em;
        padding-left: 1em;
        padding-right: 1em;
        margin-top: 1.5em;
        border-radius: 0.5em;
    }

    .linkText {
        font-size: 1em;
        font-weight: bold;
    }
</style>
